module.exports = __webpack_public_path__ + "img/glasstype-reading.7bee2bba.svg";